import { RouteWaypoint as RouteWaypointDomain } from "@iventis/domain-model/model/routeWaypoint";
import { OptionalExceptFor } from "@iventis/types";

export type RouteWaypoint = OptionalExceptFor<RouteWaypointDomain, "coordinates" | "name">;
